const COURSE_EMOJIS = [
  { emoji: '🧪', gradientFrom: '#7dd3fc', gradientTo: '#0ea5e9' }, // Science
  { emoji: '📚', gradientFrom: '#fcd34d', gradientTo: '#f59e0b' }, // Books
  { emoji: '🧠', gradientFrom: '#c4b5fd', gradientTo: '#8b5cf6' }, // Brain
  { emoji: '🔍', gradientFrom: '#a5f3fc', gradientTo: '#06b6d4' }, // Magnifying glass
  { emoji: '🚀', gradientFrom: '#fda4af', gradientTo: '#f43f5e' }, // Rocket
  { emoji: '🌍', gradientFrom: '#86efac', gradientTo: '#22c55e' }, // Globe
  { emoji: '🔬', gradientFrom: '#d8b4fe', gradientTo: '#a855f7' }, // Microscope
  { emoji: '🧮', gradientFrom: '#fecaca', gradientTo: '#ef4444' }, // Abacus
  { emoji: '🧩', gradientFrom: '#fdba74', gradientTo: '#f97316' }, // Puzzle
  { emoji: '💻', gradientFrom: '#93c5fd', gradientTo: '#3b82f6' }, // Computer
  { emoji: '📝', gradientFrom: '#e9d5ff', gradientTo: '#d946ef' }, // Note
  { emoji: '🔭', gradientFrom: '#bfdbfe', gradientTo: '#60a5fa' }, // Telescope
  { emoji: '📊', gradientFrom: '#a7f3d0', gradientTo: '#10b981' }, // Chart
  { emoji: '🧫', gradientFrom: '#c7d2fe', gradientTo: '#6366f1' }, // Petri dish
  { emoji: '🔢', gradientFrom: '#fbcfe8', gradientTo: '#ec4899' }, // Numbers
  { emoji: '📈', gradientFrom: '#ddd6fe', gradientTo: '#8b5cf6' }, // Graph increasing
  { emoji: '🧲', gradientFrom: '#fde68a', gradientTo: '#d97706' }, // Magnet
  { emoji: '⚙️', gradientFrom: '#d1d5db', gradientTo: '#6b7280' }, // Gear
  { emoji: '🧿', gradientFrom: '#93c5fd', gradientTo: '#1d4ed8' }, // Nazar amulet
  { emoji: '🔋', gradientFrom: '#a7f3d0', gradientTo: '#059669' }  // Battery
];


const TUTOR_EMOJIS = [
  { emoji: '👩‍🏫', gradientFrom: '#a5b4fc', gradientTo: '#6366f1' }, // Woman Teacher
  { emoji: '👨‍🏫', gradientFrom: '#93c5fd', gradientTo: '#3b82f6' }, // Man Teacher
  { emoji: '👩‍🔬', gradientFrom: '#f0abfc', gradientTo: '#d946ef' }, // Woman Scientist
  { emoji: '👨‍🔬', gradientFrom: '#c4b5fd', gradientTo: '#8b5cf6' }, // Man Scientist
  { emoji: '👩‍💻', gradientFrom: '#6ee7b7', gradientTo: '#10b981' }, // Woman Technologist
  { emoji: '👨‍💻', gradientFrom: '#a7f3d0', gradientTo: '#059669' }, // Man Technologist
  { emoji: '🧑‍🔬', gradientFrom: '#fda4af', gradientTo: '#f43f5e' }, // Scientist
  { emoji: '🧑‍🏫', gradientFrom: '#fdba74', gradientTo: '#f97316' }, // Teacher
  { emoji: '🧑‍💻', gradientFrom: '#fcd34d', gradientTo: '#f59e0b' }, // Technologist
  { emoji: '👩‍⚕️', gradientFrom: '#a5f3fc', gradientTo: '#06b6d4' }, // Woman Health Worker
  { emoji: '👨‍⚕️', gradientFrom: '#bae6fd', gradientTo: '#0ea5e9' }, // Man Health Worker
  { emoji: '👩‍🚀', gradientFrom: '#e9d5ff', gradientTo: '#a855f7' }, // Woman Astronaut
  { emoji: '👨‍🚀', gradientFrom: '#86efac', gradientTo: '#22c55e' }, // Man Astronaut
  { emoji: '👩‍🎓', gradientFrom: '#fecaca', gradientTo: '#ef4444' }, // Woman Student
  { emoji: '👨‍🎓', gradientFrom: '#d8b4fe', gradientTo: '#9333ea' }, // Man Student
  { emoji: '🧙‍♀️', gradientFrom: '#c7d2fe', gradientTo: '#4f46e5' }, // Woman Mage
  { emoji: '🧙‍♂️', gradientFrom: '#f9a8d4', gradientTo: '#ec4899' }, // Man Mage
  { emoji: '🦸‍♀️', gradientFrom: '#bfdbfe', gradientTo: '#2563eb' }, // Woman Superhero
  { emoji: '🦸‍♂️', gradientFrom: '#fbb4b4', gradientTo: '#dc2626' }, // Man Superhero
  { emoji: '🧠', gradientFrom: '#e9d5ff', gradientTo: '#a855f7' }  // Brain
];

/**
 * Generate an emoji and gradient colors based on a course ID
 * @param {string} id - The course ID to use for generating the visual style
 * @returns {Object} An object with emoji, gradientFrom, and gradientTo properties
 */
export const getCourseVisualStyle = (id) => {
  // If id is undefined or null, use a default index
  if (!id) {
    return COURSE_EMOJIS[0];
  }

  // Create a simple hash from the id string
  const hash = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  // Use the hash to select an emoji from the array
  const index = hash % COURSE_EMOJIS.length;
  return COURSE_EMOJIS[index];
};

/**
 * Generate a people emoji and gradient colors based on a tutor ID
 * @param {string} id - The tutor ID to use for generating the visual style
 * @returns {Object} An object with emoji, gradientFrom, and gradientTo properties
 */
export const getTutorVisualStyle = (id) => {
  // If id is undefined or null, use a default index
  if (!id) {
    return TUTOR_EMOJIS[0];
  }

  // Create a simple hash from the id string
  const hash = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  // Use the hash to select an emoji from the array
  const index = hash % TUTOR_EMOJIS.length;
  return TUTOR_EMOJIS[index];
}; 
